(function () {

  'use strict';

  document.querySelectorAll('[data-ef-root]').forEach(function (root) {

    var node = root.querySelector('[data-ef-product-json]');

    if (!node) return;

    var product;

    try {
      product = JSON.parse(node.textContent);
    } catch (e) {
      return;
    }

    var flowers = Array.from(
      root.querySelectorAll('[data-ef-flower]')
    );

    var scents = Array.from(
      root.querySelectorAll('[data-ef-scent]')
    );

    var result = root.querySelector('[data-ef-result]');

    var image = root.querySelector('[data-ef-result-image]');

    var flowerText = root.querySelector(
      '[data-ef-result-flower]'
    );

    var scentText = root.querySelector(
      '[data-ef-result-scent]'
    );

    var priceText = root.querySelector(
      '[data-ef-result-price]'
    );

    var status = root.querySelector('[data-ef-status]');

    var add = root.querySelector('[data-ef-add]');


    /* ==============================
       初期画像
    ============================== */

    function getImageUrl(value) {

      if (!value) return '';

      if (typeof value === 'string') return value;

      return value.src || value.url || '';

    }

    var productImage =
      getImageUrl(product.featured_image) ||
      getImageUrl(product.images && product.images[0]);

    var bloomButton = flowers.find(function (button) {
      return String(button.dataset.efFlower || '')
        .trim()
        .toUpperCase() === 'BLOOM';
    });

    var bloomImage =
      bloomButton
        ? bloomButton.dataset.efImage || ''
        : '';

    var firstFlowerImage =
      flowers.length > 0
        ? flowers[0].dataset.efImage || ''
        : '';

    var defaultImage =
      bloomImage ||
      productImage ||
      firstFlowerImage;

    var state = {

      flower: '',

      scent: '',

      image: defaultImage,

      alt: product.title || 'ETERNAL FLOWER'

    };


    /* ==============================
       オプション名の判定
    ============================== */

    function norm(value) {

      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[\s　_\-・]/g, '');

    }

    function optionIndex(pattern, fallback) {

      var index = (product.options || []).findIndex(
        function (value) {
          return pattern.test(norm(value));
        }
      );

      return index < 0 ? fallback : index;

    }

    var flowerIndex = optionIndex(
      /花|flower/,
      0
    );

    var scentIndex = optionIndex(
      /香|fragrance|scent|aroma/,
      flowerIndex === 0 ? 1 : 0
    );


    /* ==============================
       価格表示
    ============================== */

    function money(cents) {

      return (
        '¥' +
        Math.round(Number(cents || 0) / 100)
          .toLocaleString('ja-JP') +
        '（税込）'
      );

    }


    /* ==============================
       選択中のバリエーション取得
    ============================== */

    function variant() {

      if (!state.flower || !state.scent) {
        return null;
      }

      return (product.variants || []).find(
        function (item) {

          return (
            norm(item.options[flowerIndex]) ===
              norm(state.flower) &&
            norm(item.options[scentIndex]) ===
              norm(state.scent)
          );

        }
      ) || null;

    }


    /* ==============================
       選択状態の表示
    ============================== */

    function select(buttons, current) {

      buttons.forEach(function (button) {

        var active = button === current;

        button.classList.toggle(
          'is-selected',
          active
        );

        button.setAttribute(
          'aria-pressed',
          active ? 'true' : 'false'
        );

      });

    }


    /* ==============================
       選択結果を更新
    ============================== */

    function update(scroll) {

      var selectedVariant = variant();

      flowerText.textContent =
        state.flower ||
        'お花を選択してください';

      scentText.textContent =
        state.scent ||
        '香りを選択してください';


      /* 未選択時にも初期画像を表示 */

      if (state.image && image) {

        image.src = state.image;

        image.alt =
          state.alt ||
          (
            state.flower
              ? 'ETERNAL FLOWER ' + state.flower
              : 'ETERNAL FLOWER'
          );

        image.hidden = false;

      }


      add.dataset.variantId =
        selectedVariant
          ? selectedVariant.id
          : '';

      add.disabled =
        !selectedVariant ||
        !selectedVariant.available;


      if (!state.flower || !state.scent) {

        status.textContent =
          'お花と香りをひとつずつお選びください。';

      } else if (!selectedVariant) {

        status.textContent =
          'この組み合わせの商品情報が見つかりませんでした。';

      } else if (!selectedVariant.available) {

        status.textContent =
          'この組み合わせは、ただいま在庫切れです。';

      } else {

        status.textContent =
          '組み合わせをご確認のうえ、カートへお進みください。';

        priceText.textContent =
          money(selectedVariant.price);

      }


      /*
       * 画像が設定されていれば、
       * 未選択時でも結果エリアを表示
       */

      result.classList.toggle(
        'is-ready',
        !!(
          state.image ||
          state.flower ||
          state.scent
        )
      );


      if (
        scroll &&
        state.flower &&
        state.scent
      ) {

        setTimeout(function () {

          result.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });

        }, 100);

      }

    }


    /* ==============================
       お花を選択
    ============================== */

    flowers.forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          state.flower =
            button.dataset.efFlower;

          state.image =
            button.dataset.efImage ||
            defaultImage;

          state.alt =
            button.dataset.efAlt ||
            (
              'ETERNAL FLOWER ' +
              state.flower
            );

          select(flowers, button);

          update(false);

        }
      );

    });


    /* ==============================
       香りを選択
    ============================== */

    scents.forEach(function (button) {

      button.addEventListener(
        'click',
        function () {

          state.scent =
            button.dataset.efScent;

          select(scents, button);

          update(true);

        }
      );

    });


    /* ==============================
       カートへ追加
    ============================== */

    add.addEventListener(
      'click',
      async function () {

        var id = Number(
          add.dataset.variantId
        );

        if (!id) return;

        var label = add.textContent;

        add.disabled = true;

        add.textContent = '追加中…';

        try {

          var response = await fetch(
            '/cart/add.js',
            {
              method: 'POST',

              headers: {
                'Content-Type':
                  'application/json',

                'Accept':
                  'application/json'
              },

              body: JSON.stringify({
                items: [
                  {
                    id: id,
                    quantity: 1
                  }
                ]
              })
            }
          );

          if (!response.ok) {

            var body = await response
              .json()
              .catch(function () {
                return {};
              });

            throw new Error(
              body.description ||
              'カートへの追加に失敗しました。'
            );

          }

          add.textContent =
            'カートに追加しました ✓';

          status.textContent =
            'カートに追加しました。';

          document.dispatchEvent(
            new CustomEvent('cart:refresh')
          );

          document.dispatchEvent(
            new CustomEvent('cart:updated')
          );

          setTimeout(function () {

            add.textContent = label;

            add.disabled = false;

          }, 2500);

        } catch (error) {

          status.textContent =
            error.message ||
            'カートへの追加に失敗しました。';

          add.textContent = label;

          add.disabled = false;

        }

      }
    );


    /* 初期表示 */

    update(false);

  });

})();